import React, { ReactElement } from "react"
import { Item, Tag, Link } from "@wfp/ui"

const ErrorState = (): ReactElement => {
  return (
    <Item>
      <Tag type="error">Error</Tag>
      <p>Something went wrong</p>
      <p>
        <Link href="https://www.wfp.org">WFP Homepage</Link>
      </p>
    </Item>
  )
}

export default ErrorState
